import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "../common/commonDomain";
import {
  ApproveNominationCommitteeRemuneration,
  ApproveNominationCommitteeRemunerationForm,
} from "./approveNominationCommitteeRemunerationDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ApproveNominationCommitteeRemuneration,
): ApproveNominationCommitteeRemunerationForm {
  return new ApproveNominationCommitteeRemunerationForm(dispatch, context, data);
}

export function isValid(form: ApproveNominationCommitteeRemunerationForm): boolean {
  return form.isValid;
}

export function validate(form: ApproveNominationCommitteeRemunerationForm): boolean {
  return form.validate();
}

export function applyForm(
  form: ApproveNominationCommitteeRemunerationForm,
): ApproveNominationCommitteeRemuneration {
  return {
    type: DecisionType.approveNominationCommitteeRemuneration,
    isReceive: form.isReceive.value,
    remunerationPeriods: form.remunerationPeriods.value.slice(),
    nominationCommitteeRemuneration: form.newNominationCommittee.map((e) => ({
      id: e.id,
      name: e.name,
      value: e.valueField.toNumberOrZero(),
    })),
    nominationCommitteeRemunerationByName: form.nominationCommitteeRemuneration.map((e) => ({
      id: e.id,
      name: e.name,
      value: e.valueField.toNumberOrZero(),
    })),
  };
}

export function handleEvent(form: ApproveNominationCommitteeRemunerationForm, event: DbotEvent) {
  form.handleEvent(event);
}

export const approveNominationCommitteeRemunerationHandler: DecisionTypeHandler<
  DecisionType.approveNominationCommitteeRemuneration,
  ApproveNominationCommitteeRemuneration,
  ApproveNominationCommitteeRemunerationForm
> = {
  type: DecisionType.approveNominationCommitteeRemuneration,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
